import BaseRequest from './BaseRequest';

const schema = 'statistic';
/**
 * key base on host:port
 */
export default class StatisticRequest extends BaseRequest {
  /**
   *
   * @returns {Promise<BaseRequest._responseHandler.props.data|undefined>}
   */

  fetchInOutOrderTrans(params) {
    const url = `${schema}/inout-order-trans`;
    return this.get(url, params);
  }

  fetchInOutTrans(params) {
    const url = `${schema}/inout-trans`;
    return this.get(url, params);
  }

  fetchInOutTransExternal(params) {
    const url = `${schema}/inout-trans-external`;
    return this.get(url, params);
  }

  fetchWalletBalance(params) {
    const url = `${schema}/wallet-balance`;
    return this.get(url, params);
  }

  fetchTrans(params) {
    const url = `${schema}/trans`;
    return this.get(url, params);
  }

  fetchExtTrans(params) {
    const url = `${schema}/ext-trans`;
    return this.get(url, params);
  }

  fetchOrderTrans(params) {
    const url = `${schema}/order-trans`;
    return this.get(url, params);
  }

  fetchInOutOrderTransChart(params) {
    const url = `${schema}/inout-order-trans-chart`;
    return this.get(url, params);
  }

  fetchInOutTransChart(params) {
    const url = `${schema}/inout-trans-chart`;
    return this.get(url, params);
  }

  fetchInOutTransExternalChart(params) {
    const url = `${schema}/inout-trans-external-chart`;
    return this.get(url, params);
  }
}
